<template>
	<div class="spinner-container">
		<div class="custom-spinner"></div>
	</div>
</template>

<script setup></script>
